import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    // useLayoutEffect fires synchronously before paint, avoiding a mid-page flash
    // when the hamburger menu closes and unlocks body scroll.
    window.scrollTo(0, 0);
    // Also queue a rAF to catch the tick after the menu unlocks scroll
    const raf = requestAnimationFrame(() => window.scrollTo(0, 0));
    return () => cancelAnimationFrame(raf);
  }, [pathname]);
  return null;
}

